import { t } from '../i18n';
import { DisplayPackage } from '../types/revenuecat';
import { getCurrencySymbol } from './currency';

// Plan names and per-month prices are worked out when rendered, not when the
// plans load, so they follow the language switcher. The Stripe product name
// is English and stays the fallback for plans that aren't 1 or 12 months.

/** Months the package covers (Stripe metadata.months), if known. */
export const packageMonths = (pkg: DisplayPackage): number | undefined =>
  (pkg as DisplayPackage & { _sortMonths?: number })._sortMonths;

export const planName = (pkg: DisplayPackage): string => {
  const months = packageMonths(pkg);
  if (months === 12) return t('offers.planYearly');
  if (months === 1) return t('offers.planMonthly');
  return pkg.product.title;
};

/** "CA$7.50 / month" in the active language. */
export const perMonthText = (pkg: DisplayPackage): string => {
  const months = packageMonths(pkg);
  if (!months) return pkg.product.price_string ?? '';
  const symbol = getCurrencySymbol(pkg.product.currency || 'gbp');
  return t('billing.monthlyPrice', { price: `${symbol}${((pkg.product.price || 0) / 100 / months).toFixed(2)}` });
};
